import type { ReactNode } from "react";

type Variant = "success" | "warning" | "danger" | "info" | "neutral";

interface BadgeProps {
  children: ReactNode;
  variant?: Variant;
  icon?: ReactNode;
  className?: string;
}

const variantClass: Record<Variant, string> = {
  success: "badge-success",
  warning: "badge-warning",
  danger:  "badge-danger",
  info:    "badge-info",
  neutral: "badge-neutral",
};

export function Badge({ children, variant = "neutral", icon, className = "" }: BadgeProps) {
  return (
    <span className={`${variantClass[variant]} ${className} gap-1`}>
      {icon && <span aria-hidden className="inline-flex">{icon}</span>}
      {children}
    </span>
  );
}
